<template>
  <div class="parent">
    <div class="bg_img">
      <div class="login-container">
        <el-form :model="accountRegisterForm" label-width="40px" class="demo-ruleForm" size="mini"
                 style="padding-top: 60px;" :rules="rules" ref="accountRegisterForm">
          <el-form-item label="账号" prop="username" class="register_input">
            <el-input v-model="accountRegisterForm.username" placeholder="请输入账号"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password" class="register_input">
            <el-input type="password" v-model="accountRegisterForm.password" placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-button size="mini" style="margin-left: 53px;" type="warning"
                     @click="handleAccountRegister('accountRegisterForm')">注册
          </el-button>
          <el-button size="mini" type="primary" @click="handleAccountFastRegister">一键注册</el-button>
        </el-form>
      </div>
        <el-link type="primary" style="margin-top: 10px" @click="handleCloseRegister">前往登录</el-link>
    </div>
    <el-dialog
        title="注册成功"
        :visible.sync="dialogVisible"
        top="38vh"
        :before-close="handleClose"
        width="357px"
        :close-on-click-modal=false
        center>
      <div>账号密码请截图存放至系统相册</div>
      <div style="margin:10px 0">账号：{{ info_obj.username }}</div>
      <div>密码：{{ info_obj.password }}</div>
      <span slot="footer" class="dialog-footer">
  </span>
    </el-dialog>
    <div>
      <RealName :show="bind_real_open" @child-real="BindRealNameClick"></RealName>
    </div>
  </div>
</template>

<script>
import Message from '@/mixins/Message';
import {txPostRequest} from "@/plugins/request";
import {globalStorage} from "@/util/tool";
import RealName from "@/components/ball/RealName.vue"

export default {
  name: 'UserRegister',
  mixins: [Message],
  components: {RealName},
  data() {
    const validateUsernames = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入账号'));
      } else if (value.length < 8 || value.length > 32) {
        callback(new Error('账号只允许8-32个字符'));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (value.length < 6 || value.length > 32) {
        callback(new Error('密码只允许6-32个字符'));
      } else {
        callback();
      }
    };
    return {
      rules: {
        username: [
          {validator: validateUsernames, trigger: 'blur'}
        ],
        password: [
          {validator: validatePassword, trigger: 'blur'}
        ],
      },
      dialogVisible: false,
      info_obj:{

      },
      bind_real_open:false,
      game_id:'',
      real_name:'',
      accountRegisterForm: {
        username: '',
        password: '',
      }
    };
  },
  methods: {
    BindRealNameClick(type,real_success){
      this.bind_real_open=type
      if (real_success){
        globalStorage.set('updateUserParams',{'isShowIframe':true})
      }
    },
    handleAccountLogin() {
      console.log('账号密码登录:', this.accountRegisterForm);
    },
    handleAccountRegister(formName) {
      this.$refs[formName].validate(async (valid) => {
        console.log(valid)
        if (valid) {
          let {code,message} =await txPostRequest('/user/register', {
            username: this.accountRegisterForm.username,
            password: this.accountRegisterForm.password
          })
          if (code!==0){
            return this.errorMessage(message)
          }
          this.successMessage()
        } else {
          console.log('error submit!!');
          return false;
        }
      })
    },
    handleCloseRegister(){
      this.$emit('child-register_close');
    },
   async handleAccountFastRegister() {
     let {code,message,data}  = await txPostRequest('/user/fast_register')
     if (code!==0){
       return this.errorMessage(message)
     }
     this.info_obj=data
     this.dialogVisible = true
     let {username,uid,access_token,qudao_id=1}={...data}
     globalStorage.set('updateUserParams',{acc:username,access_token:access_token})
     globalStorage.set('updateReportParams',{username,uid,access_token,qudao_id})

    },
    async handleClose(done) {
      done();
      let {code,message,data}  =await txPostRequest('/game/login', {game_id: this.game_id})
      if (code!==0){
        return this.errorMessage(message)
      }
      let obj=this.info_obj
      let {username,access_token,uid,qudao_id=1}={...obj}
      let info=JSON.stringify( {username,access_token,uid,qudao_id})
      localStorage.setItem("userInfo", info)
      globalStorage.set('updateUserParams',{'link':data})
      this.$router.replace({ name: 'login' ,params: { game_id:this.game_id}});
        //请先实名
      this.bind_real_open=true
    },
    handleClick(tab, event) {
      console.log(tab, event);
    }
  },
  mounted() {
    this.game_id=globalStorage.get_value('getUserParams','game_id')
  }
};
</script>

<style scoped>
.login-container {
  max-width: 256px;
  margin-left: 20px;
}

.bg_img {
  background-image: url('@/assets/login_bg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 280px;
  width: 317px;
}

.parent {
  display: flex; /* 声明为Flex容器 */
  align-items: center; /* 子元素在交叉轴上的对齐方式，这里是垂直居中 */
  justify-content: center; /* 可选，子元素在主轴上的对齐方式，这里是水平居中 */
  height: 100%; /* 指定容器的高度，以便看到垂直居中的效果 */
}

/deep/ .el-message {
  top: 34% !important;
  min-width: 265px !important;
  padding: 8px !important;
}

.register_input {
  margin-left: 30px;
}
</style>
